import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const Ctx = createContext({ features: [], enabled: () => true, status: () => "on", reload: () => {} });

// Global feature registry (server-authoritative; the backend returns 403 FEATURE_DISABLED regardless of what the UI shows).
export function FeatureProvider({ children }) {
  const [features, setFeatures] = useState([]);
  const reload = useCallback(() => api.get("/features").then(({ data }) => setFeatures(data.features)).catch(() => {}), []);
  useEffect(() => { reload(); const id = setInterval(reload, 60000); return () => clearInterval(id); }, [reload]);
  const value = useMemo(() => {
    const map = Object.fromEntries(features.map((f) => [f.key, f]));
    return { features, reload, enabled: (key) => (map[key] ? map[key].available !== false : true), status: (key) => map[key]?.status ?? "on" };
  }, [features, reload]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useFeatures = () => useContext(Ctx);

export function FeatureUnavailable({ name }) {
  return <div className="p-6 text-center text-sm text-muted-foreground" data-testid="feature-unavailable">{name} is currently unavailable.<div className="text-[11px] mt-1">Disabled by the platform administrator.</div></div>;
}
